const VERSION = "5.2.2";
export {
  VERSION
};
